export default "__VITE_ASSET__Bknn8NHq__"